import React, {useState, useEffect, useCallback} from 'react';
import './assets/styles/style.css';
import {Chats, AnswersList} from './components/index';
import FormDialog from './components/Forms/FormDialog';
import exportFunction from './assets/export.js';
import {db} from './firebase/index';
import {collection, getDocs} from 'firebase/firestore/lite';
// dataset02.js 用
// import defaultDataset from './dataset02';

const App = () => {
  const [answers, setAnswers] = useState([]);            // 回答コンポーネントに表示するデータ
  const [chats, setChats] = useState([]);                // チャットコンポーネントに表示するデータ
  const [currentId, setCurrentId] = useState('init');    // 現在の質問ID
  const [dataset, setDataset] = useState({});            // 質問と回答のデータセット
  const [open, setOpen] = useState(false);               // 問い合わせフォーム用モーダルの開閉を管理
    
  // componentDidMount() ---start 
  useEffect(() => {
    (async () => {

      const initDataset = {};
      await getDocs(collection(db, 'questions')).then(snapshots => {
        snapshots.forEach(doc => {
          const id = doc.id;
          const data = doc.data();
          initDataset[id] = data;
        });
      });

      // dataset02.js 用
      // const initDataset = defaultDataset;

      setDataset(initDataset);
      displayNextQuestion(currentId, initDataset[currentId]);
    })();
  }, []);
  
  useEffect(() => {
    const scrollArea = document.getElementById('scroll-area');
    if (scrollArea) {
      scrollArea.scrollTop = scrollArea.scrollHeight;
    }
  });

  const selectAnswer = useCallback((selectedAnswer, nextQuestionId) => {
    switch (true) {
      case (nextQuestionId === 'contact'):
        handleOpen();
        break;
      case /^https:*/.test(nextQuestionId):
        const a = document.createElement('a');
        a.href = nextQuestionId;
        a.target = '_blank';
        a.click();
        break;
      default:
        addChats({
          text: selectedAnswer,
          type: 'answer'
        })
        exportFunction.speechText(selectedAnswer);
        setTimeout(() => exportFunction.speechText('ですね'), 1000);
        setTimeout(() => displayNextQuestion(nextQuestionId, dataset[nextQuestionId]), 1600);
        break;
    }
  }, [answers]);

  const addChats = useCallback((chat) => {
    setChats(prevChats => {
      return [...prevChats, chat]
    })
  }, [setChats]);

  const displayNextQuestion = (nextQuestionId, nextDataset) => {
    addChats({
      text: nextDataset.question,
      type: 'question'
    });
    setTimeout(() => setAnswers(nextDataset.answers), 800)
    setCurrentId(nextQuestionId)

    exportFunction.speechText('では');
    setTimeout(() => exportFunction.speechText(nextDataset.question), 1000);
  }

  const handleOpen = useCallback(() => {
    setOpen(true)
  }, [setOpen]);
  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);
  // componentDidMount() ---end 

  return (
    <section className="c-section">
      <div className="c-box">
        <Chats chats={chats} />
        <AnswersList answers={answers} select={selectAnswer} />
        <FormDialog open={open} handleClose={handleClose} />
      </div>
    </section>
  );
}

export default App;
